import React, { ReactNode } from "react";
import styled from "styled-components";
import Theme from "../../theme/theme";
// import CyberEssentialsBadge from "./cyber-essentials-badge.png";

const SiteFooter = () => {
  return (
    <Theme>
      <Wrapper>
        <Footer>
          <FooterLinks>
            {/*
              The links are hardcoded to production pages as we don't really
              have a dev /staging version of the marketing site and the
              "terms of business" comes from wordpress.
            */}
            <FooterItem href="https://www.hiring-hub.com/privacypolicy/">
              Privacy policy
            </FooterItem>
            <FooterItem href="https://www.hiring-hub.com/terms-of-use/">
              Terms of use
            </FooterItem>
            <FooterItem href="https://app.hiring-hub.com/terms-of-business/">
              Terms of business
            </FooterItem>
          </FooterLinks>
         {/* <CyberBadge
            src={CyberEssentialsBadge}
            alt="Cyber Essentials Certification"
          />*/}
        </Footer>
      </Wrapper>
    </Theme>
  );
};

type FooterItemProps = {
  href: string;
  children: ReactNode;
};

const FooterItem = ({ href, children }: FooterItemProps) => {
  return (
    <FooterLink href={href} target="_blank" rel="noreferrer">
      {children}
    </FooterLink>
  );
};

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.gray100};
  margin-left: 60px;

  @media (max-width: 767px) {
    margin-bottom: 60px;
    margin-left: 0;
  }
`;

const Footer = styled.footer`
  padding: 0.5rem 2rem;
  background-color: ${({ theme }) => theme.colors.gray100};
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 100%;

  @media (max-width: 767px) {
    padding: 0.5rem 1rem;
  }
`;

const FooterLink = styled.a`
  padding: 0.25rem 1rem;
  font-size: 13px;
  display: inline-block;

  &&& {
    color: ${({ theme }) => theme.colors.gray700};

    &:hover {
      text-decoration: underline;
      color: ${({ theme }) => theme.colors.text};
    }
  }
`;

// const CyberBadge = styled.img`
//   width: 50px;
//   margin-left: 2rem;
// `;

const FooterLinks = styled.div`
  flex: 1;
  margin: 0 -1rem;
  text-align: right;
`;

export default SiteFooter;
